import { render, staticRenderFns } from "./setupDetail.vue?vue&type=template&id=f62023d2&scoped=true"
import script from "./setupDetail.vue?vue&type=script&lang=js"
export * from "./setupDetail.vue?vue&type=script&lang=js"
import style0 from "./setupDetail.vue?vue&type=style&index=0&id=f62023d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62023d2",
  null
  
)

export default component.exports